<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import CityAutocomplete from '~/components/search/forms/CityAutocomplete.vue'
    import {AirportsSearchMixin} from '~/mixins/AirportsSearchMixin.vue'

    @Component({
        mixins: [CityAutocomplete],
    })
    export class CityAirportAutocomplete extends AirportsSearchMixin {
        itemLabel(entry) {
            return entry.type === 'city'
                ? `${entry.cityName}, ${entry.countryName}`
                : `${entry.name}, ${entry.cityName}, ${entry.countryName}`
        }

        async initSearch(val) {
            this.tryResearch.status = false

            if ((this.entries.length > 0 && this.entries.indexOf(val) !== -1) || !val) return
            this.loading = true
            if (this.cancelTokenSource) this.cancelTokenSource.cancel('Operation canceled by the user.')
            this.cancelTokenSource = this.$axios.CancelToken.source()

            try {
                const rs = await this.$api.airports.get(
                    {
                        pattern: val.trim(),
                        limit: 10,
                        orderBy: 'POPULARITY',
                    },
                    this.cancelTokenSource.token
                )
                const cityGroups = rs.reduce((cityGroups, location) => {
                    let cityGroup = cityGroups.find(cityGroup => cityGroup.city.id === location.cityId)
                    if (!cityGroup) {
                        const city = location.type === 'city' ? location : {id: location.cityId}
                        cityGroup = {
                            city,
                            airports: [],
                        }
                        cityGroups.push(cityGroup)
                    }
                    if (location.type === 'city') {
                        cityGroup.city = location
                    } else {
                        cityGroup.airports.push(location)
                    }
                    return cityGroups
                }, [])

                this.entries = cityGroups.reduce((entries, cityGroup) => {
                    if (cityGroup.city.cityId) {
                        entries.push(cityGroup.city)
                    }
                    return [...entries, ...cityGroup.airports]
                }, [])
                if (this.entries.length === 0) {
                    this.tryResearch.status = true
                    this.tryResearch.message = this.isMobile
                        ? this.$t('try_rewrite_destination_mobile')
                        : this.$t('try_rewrite_destination')
                }
            } catch (e) {
                /* empty */
            } finally {
                this.loading = false
            }
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }

        get airportIcon() {
            return 'mdi-airplane-takeoff'
        }

        icon(type) {
            switch (type) {
                case 'airport':
                    return this.airportIcon
                default:
                    return this.locationIcon
            }
        }
    }

    export default {...toNative(CityAirportAutocomplete), ssrRender: CityAutocomplete.ssrRender}
</script>

<style scoped lang="scss">
    :deep(.v-dialog) {
        overflow-y: hidden;
    }
    :deep(.v-label) {
        font-size: inherit;
    }

    :deep(.v-autocomplete__selection) {
        line-height: unset !important;
        height: unset !important;
        display: flex;
        align-items: start;
    }
</style>
